// Job application stats  *************************************************************************
// pathname: /v1/job-operation/{jobSlug}/application-stats
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi';

interface JobApplicationStatsProps {
  jobSlug: string;
  shouldFetch?: boolean;
  locale?: string;
  serverSideData?: {
    [key: string]: number;
  };
}

/**
 * @description SWR: fetch job application stats.
 *
 * * **jobSlug**: string. The job slug.
 * * **shouldFetch**: boolean. Whether to start fetch job application stats (eg: fetch only for logged-in users). Default true.
 * * **locale**: string. The locale to use for the request. Default: 'ro'.
 * * **serverSideData**: { [key: string]: number; }. It holds the data retrieved from the server-side request. Optional.
 */

export const useSwrJobApplicationStats = (props: JobApplicationStatsProps) => {
  // Destructure props
  const {
    jobSlug, shouldFetch = true, locale = 'ro', serverSideData,
  } = props;

  // SWR: fetch data
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<{
    [key: string]: number;
  }>({
    url: `/v2/job-operation/${jobSlug}/application-stats`,
    shouldFetch,
    locale,
    serverSideData,
    apiOptions: {
      dedupingInterval: 1000 * 60, // 1 minute
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
